import { AppContext } from "approot/global/services/context";
import { postTo } from "./common.navigation";

declare var $: any;
declare var window: any;

export class CommonXhrErrorHandler {
	constructor(
		private errorInformer?: (text: string) => Promise<any>,
		private messageInformer?: (text: string) => Promise<any>,
		private appContextAccessor?: () => AppContext,
		private language?: any
	) {
		this.errorInformer = errorInformer || $.show.error;
		this.messageInformer = messageInformer || $.show.message;
		this.appContextAccessor = appContextAccessor || (() => window.appContext);
		this.language = language || window.language;
	}

	getErrorResponseMessage(response) {
		if (response.status === 401) {
			let authError = response.headers("auth-error");
			if (authError === "SessionExpired") {
				return this.language.Generic.Common.kTimeOutOccured4Ajax;
			}
			else {
				return this.language.Generic.Common.kErrPageAccess;
			}
		}

		if (response.status === 503) {
			return response.statusText;
		}

		if (response.status === 404 && response.config) {
			let errMessage = response.statusText + " " + response.config.url;
			return errMessage;
		}

		let message = response.data && (response.data.message || response.data.details);
		let details = response.data && response.data.details;
		let stackTrace = response.data && response.data.stackTrace;

		if (response.data && response.data.isInformation) {
			return message;
		}

		let displayMsg = message;
		let environment = this.appContextAccessor()?.environment;
		if (environment != "prod" && (details || stackTrace)) {
			let debugPanel = "<div class='debug-panel'>";
			if (details) {
				debugPanel += "<p class='title'>Details:</span><div>" + details + "</div>"
			}
			if (stackTrace) {
				debugPanel += "<p class='title'>StackTrace:</span><div class='stack'>" + stackTrace + "</div>"
			}
			displayMsg += debugPanel + "</div>";
		}
		return displayMsg || this.language.Generic.Common.kUnexpErr;
	}

	handleErrorResponse(response) {
		$(document).trigger("closeProcessing");

		if (response.status === 401) {
			let authError = response.headers("auth-error");
			if (authError === "SessionExpired") {
				this.messageInformer(this.language.Generic.Common.kTimeOutOccured4Ajax)
					.then(() => {
						if(window.opener){
							window.close();
						}
						postTo({ path: "/", method: "GET" })
					});
			}
			else {
				this.messageInformer(this.language.Generic.Common.kErrPageAccess)
					.then(() => {
						if (this.appContextAccessor().emId) {
							postTo({ path: "/app/em/mysettings/" });
						}
						else {
							if (!this.appContextAccessor().schoolId && !this.appContextAccessor().emId && !this.appContextAccessor().mainSchoolId) {
								postTo({ path: "/app/admin/mysettings/" });
							}
							else {
								postTo({ path: "/app/school/mysettings/" });
							}
						}
					});
			}
			return Promise.reject(response);
		}

		if (response.status === 503) {
			this.errorInformer(response.statusText);
			return Promise.reject(response);
		}

		if (response.status === 404 && response.config) {
			let errMessage = response.statusText + " " + response.config.url;
			this.errorInformer(errMessage);
			return Promise.reject(response);
		}

		let message = response.data && (response.data.message || response.data.details);
		let details = response.data && response.data.details;
		let stackTrace = response.data && response.data.stackTrace;

		if (response.data && response.data.isInformation) {
			this.messageInformer(message);
			return Promise.reject(response);
		}

		let displayMsg = message;
		let environment = this.appContextAccessor()?.environment;
		if (environment != "prod" && (details || stackTrace)) {
			let debugPanel = "<div class='debug-panel'>";
			if (details) {
				debugPanel += "<p class='title'>Details:</span><div>" + details + "</div>"
			}
			if (stackTrace) {
				debugPanel += "<p class='title'>StackTrace:</span><div class='stack'>" + stackTrace + "</div>"
			}
			displayMsg += debugPanel + "</div>";
		}
		this.errorInformer(displayMsg || this.language.Generic.Common.kUnexpErr);
		return Promise.reject(response);
	}
}